"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _Select = require("../form/Select");

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherForm, _Component);

  function VoucherForm() {
    (0, _classCallCheck3.default)(this, VoucherForm);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherForm.__proto__ || (0, _getPrototypeOf2.default)(VoucherForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          voucher = _props.voucher,
          soil_types = _props.fields.soil_types;

      if (voucher.soil_types.length === 1) {
        soil_types.onChange(voucher.soil_types[0].id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$fields = this.props.fields,
          address = _props$fields.address,
          postal_area = _props$fields.postal_area,
          contractor = _props$fields.contractor,
          company = _props$fields.company,
          register_number = _props$fields.register_number,
          driver = _props$fields.driver;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h2",
          { className: "h4" },
          "Lipukkeen esit\xE4ytt\xF6:"
        ),
        _react2.default.createElement(
          "form",
          { id: "voucher-form" },
          _react2.default.createElement(_Input2.default, {
            id: "address",
            type: "text",
            label: "L\xE4ht\xF6osoite",
            fieldProps: address,
            small: true
          }),
          _react2.default.createElement(_Input2.default, {
            id: "postal_area",
            type: "text",
            label: "Paikkakunta",
            fieldProps: postal_area,
            small: true
          }),
          _react2.default.createElement(_Input2.default, {
            id: "contractor",
            type: "text",
            label: "Ajon tilaaja",
            fieldProps: contractor,
            small: true
          }),
          _react2.default.createElement(_Input2.default, {
            id: "company",
            type: "text",
            label: "Kuljetusliike",
            fieldProps: company,
            small: true
          }),
          _react2.default.createElement(_Input2.default, {
            id: "register_number",
            type: "text",
            label: "Auton rekisterinumero",
            fieldProps: register_number,
            small: true
          }),
          _react2.default.createElement(_Input2.default, {
            id: "driver",
            type: "text",
            label: "Kuljettaja",
            fieldProps: driver,
            small: true
          }),
          this.renderSelect()
        )
      );
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _props2 = this.props,
          voucher = _props2.voucher,
          soil_types = _props2.fields.soil_types;

      if (voucher.soil_types.length > 1) {
        return _react2.default.createElement(_Select2.default, {
          disableLabel: true,
          small: true,
          options: voucher.soil_types,
          fieldProps: soil_types,
          placeholder: "Valitse maa-aines"
        });
      }
    }
  }]);
  return VoucherForm;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  voucher: _react.PropTypes.object.isRequired
}, _temp);
exports.default = VoucherForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/uservouchers/VoucherForm.js
 ** module id = 1197
 ** module chunks = 0
 **/